// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-UK8OP, .main-\\+SSCQ, .header-Fk8vH, .headerText-JlBxm, .footer-li-fd, .overlay-7pwXG {\n  all: initial;\n  font: inherit;\n  box-sizing: inherit;\n}\n.content-UK8OP {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  z-index: 1007;\n  background-color: #fff;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.content-UK8OP .header-Fk8vH {\n  flex: 0 0 auto;\n  display: block;\n  min-height: 55px;\n  padding: 15px 20px 15px 30px;\n  border-bottom: 1px solid #dddddd;\n}\n.content-UK8OP .header-Fk8vH .title-tKtOA {\n  color: #554854;\n  font-size: 25px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n.content-UK8OP .header-Fk8vH .header-default-9-0mI {\n  position: relative;\n  padding: 30px 30px 5px;\n}\n.content-UK8OP .header-Fk8vH .header-extension-h28OE {\n  padding: 0 30px;\n}\n.content-UK8OP .header-Fk8vH .closeIcon-xRpzq {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 35px;\n  opacity: 1;\n  position: absolute;\n  top: 18px;\n  right: 25px;\n  height: 35px;\n  width: 30px;\n}\n.content-UK8OP .header-Fk8vH .closeIcon-xRpzq:hover, .content-UK8OP .header-Fk8vH .closeIcon-xRpzq:focus {\n  cursor: pointer;\n}\n.content-UK8OP .header-Fk8vH .closeIcon-xRpzq:disabled {\n  color: #979797;\n}\n.content-UK8OP .header-Fk8vH .closeIcon-xRpzq .icon-UP5E0 {\n  font-size: 35px;\n  color: #999999;\n}\n.content-UK8OP .header-Fk8vH .closeIcon-xRpzq .icon-UP5E0:hover {\n  color: #4a4a4a;\n}\n.content-UK8OP .main-\\+SSCQ {\n  flex: 1 1 auto;\n  position: relative;\n  color: #333333;\n  display: block;\n  max-height: calc(100vh - 330px);\n  overflow: auto;\n}\n.content-UK8OP .main-\\+SSCQ .headerElement-xvy9x {\n  margin-left: 20px;\n}\n.content-UK8OP .main-\\+SSCQ .main-content-XI6R7 {\n  padding: 0 10px;\n  margin: 20px;\n}\n.content-UK8OP .footer-li-fd {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: 100%;\n  margin-top: 0;\n  z-index: 5;\n  border: none;\n  border-top: 1px solid #dddddd;\n  background: #f0f0f0;\n}\n.content-UK8OP .footer-li-fd button {\n  margin-right: 10px;\n}\n.base-ux6AH {\n  margin: 120px auto 0;\n}\n.base-ux6AH .footer-li-fd {\n  padding: 15px 30px;\n}\n.base-ux6AH .footer-action-2Mp35 {\n  margin-right: 5px;\n}\n.draggable-Q\\+\\+q8 {\n  border: 1px solid;\n}\n.draggable-Q\\+\\+q8 .footer-li-fd {\n  padding: 15px 30px;\n}\n.draggable-Q\\+\\+q8 .cursor-oiCIE {\n  cursor: move;\n}\n.draggable-Q\\+\\+q8 .no-cursor-wQjBJ {\n  cursor: auto;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/dialogs/base-dialog/baseDialog.less"],"names":[],"mappings":"AAIA;EAOI,YAAA;EACA,aAAA;EACA,mBAAA;AAgHJ;AA5GA;EAEI,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,aAAA;EAEA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA0GJ;AAxHA;EAiBM,cAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;EAEA,gCAAA;AAyGN;AA/HA;EAyBQ,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAyGR;AArIA;EAgCQ,kBAAA;EACA,sBAAA;AAwGR;AAzIA;EAqCQ,eAAA;AAuGR;AA5IA;EAyCQ,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAsGR;AApGQ;EAEE,eAAA;AAsGV;AAnGQ;EACE,cAAA;AAqGV;AA/JA;EA8DU,eAAA;EACA,cAAA;AAoGV;AAlGU;EACE,cAAA;AAoGZ;AAtKA;EAyEM,cAAA;EACA,kBAAA;EACA,cAAA;EAEA,cAAA;EAEA,+BAAA;EACA,cAAA;AA8FN;AA9KA;EAmFQ,iBAAA;AA8FR;AAjLA;EAuFQ,eAAA;EACA,YAAA;AA6FR;AArLA;EA6FM,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,WAAA;EACA,aAAA;EAEA,UAAA;EAEA,YAAA;EACA,6BAAA;EACA,mBAAA;AAwFN;AAjMA;EA4GQ,kBAAA;AAwFR;AApMA;EAkHI,oBAAA;AAqFJ;AAvMA;EAoHM,kBAAA;AAsFN;AA1MA;EAuHM,iBAAA;AAsFN;AA7MA;EA4HI,iBAAA;AAoFJ;AAhNA;EA+HM,kBAAA;AAoFN;AAnNA;EAmIM,YAAA;AAmFN;AAtNA;EAuIM,YAAA;AAkFN","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/colors/colors-default.less';\n@import '@cirrus/legacy/app-components/app/styles/font-size-variables.less';\n@import '../dialog/variables';\n\n:local {\n  .content,\n  .main,\n  .header,\n  .headerText,\n  .footer,\n  .overlay {\n    all: initial;\n    font: inherit;\n    box-sizing: inherit;\n  }\n}\n\n:local {\n  .content {\n    position: relative;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    flex-direction: column;\n    height: auto;\n\n    z-index: 1007;\n\n    background-color: @dialog-background-color;\n    border-radius: 4px;\n    overflow: hidden;\n\n    .header {\n      flex: 0 0 auto;\n      display: block;\n      min-height: 55px;\n      padding: 15px 20px 15px 30px;\n\n      border-bottom: 1px solid @dialog-header-bottom-border-color;\n\n      .title {\n        color: @clr-gray-850;\n        font-size: 25px;\n        font-weight: bold;\n        margin-bottom: 0;\n      }\n\n      .header-default {\n        position: relative;\n        padding: 30px 30px 5px;\n      }\n\n      .header-extension {\n        padding: 0 30px;\n      }\n\n      .closeIcon {\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        font-size: @dialog-closeIcon-font-size;\n        opacity: 1;\n        position: absolute;\n        top: 18px;\n        right: 25px;\n        height: 35px;\n        width: 30px;\n\n        &:hover,\n        &:focus {\n          cursor: pointer;\n        }\n\n        &:disabled {\n          color: lighten(@dialog-close-btn-hover-color, 30%);\n        }\n\n        .icon {\n          font-size: @dialog-closeIcon-font-size;\n          color: @clr-gray-280;\n\n          &:hover {\n            color: @dialog-close-btn-hover-color;\n          }\n        }\n      }\n    }\n\n    .main {\n      flex: 1 1 auto;\n      position: relative;\n      color: @clr-gray-500;\n\n      display: block;\n      //height: 100%; commented because not worked in safari\n      max-height: ~'calc(100vh - 330px)';\n      overflow: auto;\n\n      .headerElement {\n        margin-left: 20px;\n      }\n\n      .main-content {\n        padding: 0 10px;\n        margin: 20px;\n      }\n    }\n\n    .footer {\n      flex: 0 0 auto;\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-start;\n\n      width: 100%;\n      margin-top: 0;\n\n      z-index: @dialog-footer-header-z-index;\n\n      border: none;\n      border-top: 1px solid @dialog-footer-top-border-color;\n      background: @dialog-footer-background-color;\n\n      button {\n        margin-right: 10px;\n      }\n    }\n  }\n\n  .base {\n    margin: 120px auto 0;\n    .footer {\n      padding: 15px 30px;\n    }\n    .footer-action {\n      margin-right: 5px;\n    }\n  }\n\n  .draggable {\n    border: 1px solid;\n\n    .footer {\n      padding: 15px 30px;\n    }\n\n    .cursor {\n      cursor: move;\n    }\n\n    .no-cursor {\n      cursor: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"content": "content-UK8OP",
	"main": "main-+SSCQ",
	"header": "header-Fk8vH",
	"headerText": "headerText-JlBxm",
	"footer": "footer-li-fd",
	"overlay": "overlay-7pwXG",
	"title": "title-tKtOA",
	"headerDefault": "header-default-9-0mI",
	"headerExtension": "header-extension-h28OE",
	"closeIcon": "closeIcon-xRpzq",
	"icon": "icon-UP5E0",
	"headerElement": "headerElement-xvy9x",
	"mainContent": "main-content-XI6R7",
	"base": "base-ux6AH",
	"footerAction": "footer-action-2Mp35",
	"draggable": "draggable-Q++q8",
	"cursor": "cursor-oiCIE",
	"noCursor": "no-cursor-wQjBJ"
};
export default ___CSS_LOADER_EXPORT___;
